import classNames from "classnames";
import AscButton from "../AscButton/AscButton";
import AscHeading from "../AscTypography/AscHeading/AscHeading";
import reportPreviewTeacher from "../../assets/images/preview_report_teacher.png";
import styles from "./AscReportPreview.module.scss";
import AscImage from "../AscImage/AscImage";

export interface AscReportPreviewProps {
  className?: string;
  imageUrl?: string;
  title: string;
  showPreview?: () => void;
}

export default function AscReportPreview({
  className,
  imageUrl,
  title,
  showPreview,
}: AscReportPreviewProps) {
  return (
    <div
      data-testid="asc-report-preview"
      className={classNames(styles.ground, className)}
    >
      {!imageUrl && (
        <AscImage
          src={reportPreviewTeacher}
          alt={""}
          className={styles.image}
        />
      )}

      {imageUrl}

      <div className={styles.leftSection}>
        <AscHeading level={6} className={styles.header}>
          Preview Report
        </AscHeading>
        <span className={styles.title}>{title}</span>
        <AscButton onClick={showPreview} className={styles.button}>
          Preview
        </AscButton>
      </div>
    </div>
  );
}
